import styled from "styled-components";
import { MOBILE_L_BP } from "@website-builder/utilities-index";
import("bootstrap/dist/css/bootstrap-grid.min.css");

export const Logo = styled.div`
	img {
		height: ${({ height }) => `${height}px`};
		width: ${({ width }) => `${width}px`};
		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			height: initial;
			width: 240px;
		}
	}
`;
